import {
    SET_ACTION_ITEM,
    SET_ROLE,
    GET_NOTIFICATION_COUNT,
    SET_NOTIFICATION_COUNT,
    SET_DEVICE,
    GET_DASHBOARD_DETAILS,
    SET_DASHBOARD_DETAILS,
    RESET_DETAILS,
    SET_USER_ID,
    SET_NAVIGATION,
    SET_NOTIFICATION_MESSAGE,
    BADGE_API,
    SET_ACTIVE_BADGE_COUNT,
    SET_COMPLETED_BADGE_COUNT,
    SET_FISCAL_YEAR,
    SET_FISCAL_YEAR_DATE
} from "./types";

export const setRole = (roleId) => ({
    type: SET_ROLE,
    payload: roleId,
});

export const setNavigation = (payload) => ({
    type: SET_NAVIGATION,
    payload: payload,
});
export const setActionItem = (entity, actionItem) => ({
    type: SET_ACTION_ITEM,
    payload: { entity, actionItem },
});

export const getNotificationCount = () => ({
    type: GET_NOTIFICATION_COUNT,
});

export const setNotificationCount = (payload) => ({
    type: SET_NOTIFICATION_COUNT,
    payload,
});

export const setDevice = (payload) => ({
    type: SET_DEVICE,
    payload,
});

export const resetDetails = () => ({
    type: RESET_DETAILS,
});

export const getDashboardDetails = () => ({
    type: GET_DASHBOARD_DETAILS,
});

export const setDashboardDetails = (payload) => ({
    type: SET_DASHBOARD_DETAILS,
    payload,
});

export const setNotificationMessage = (payload) => ({
    type: SET_NOTIFICATION_MESSAGE,
    payload,
});

export const setUserId = (userId) => ({
    type: SET_USER_ID,
    payload: userId,
});

export const badgeAPI = (payload) => ({
    type: BADGE_API,
    payload,
});
export const setActiveBadgeCount = (payload) => ({
    type: SET_ACTIVE_BADGE_COUNT,
    payload,
});

export const setCompletedBadgeCount = (payload) => ({
    type: SET_COMPLETED_BADGE_COUNT,
    payload,
});

export const setFiscalYear = (payload) =>  ({
    type: SET_FISCAL_YEAR,
    payload,
});


export const setFiscalYearDate = (payload) => ({
    type: SET_FISCAL_YEAR_DATE,
    payload,
});